// extracted by mini-css-extract-plugin
module.exports = {"categories":"BlogCategories_categories__2G8gb"};